module.exports = __webpack_public_path__ + "media/images/athletes/1790-d23d581c1ddf8641d48da0a09aa96a9f.png";